import posthog, { PostHog } from 'posthog-js';
import { PosthogFeatureFlags } from '@domgen/shared/enums/featureFlags';

/**
 * @description Decides whether the user gets the landing page journey (ModelSerialLanding on `/`) instead of the control journey.
 * The brand desktop flags (KitchenAid, Whirlpool) are only read when the landing page flag is not `test`, so users already on the
 * landing page journey (mobile and tablet) are never exposed to the brand desktop experiments.
 *
 * @param {Pick<PostHog, 'getFeatureFlag'>} [client] - The PostHog client to read the flags from, defaults to the posthog-js instance.
 * @returns {boolean} True if any flag puts the user on the `test` variant, false otherwise (including when PostHog has not loaded).
 */
export const isLandingPageJourney = (client: Pick<PostHog, 'getFeatureFlag'> = posthog): boolean =>
  client.getFeatureFlag(PosthogFeatureFlags.LANDING_PAGE) === 'test' ||
  client.getFeatureFlag(PosthogFeatureFlags.LANDING_PAGE_KHAID) === 'test' ||
  client.getFeatureFlag(PosthogFeatureFlags.LANDING_PAGE_WHIRL) === 'test';
